import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "MailContent" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]

import { PropType } from "vue";
import { Mail, Employee } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'MailContent',
  props: {
    mail: {
        type: Object as PropType<Mail>,
        required: true,
    },
    employee: {
        type: Object as PropType<Employee>,
        required: false,
        default: null,
    },
    canEdit: {
        type: Boolean,
        required: true,
    },
},
  setup(__props) {



const formatContent = (content: string) => {
    return content.replace(/\n/g, "<br>");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.canEdit)
      ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
          key: 0,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.mail.content) = $event))
        }, null, 512)), [
          [_vModelText, __props.mail.content]
        ])
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          innerHTML: formatContent(__props.mail.content)
        }, null, 8, _hoisted_2)),
    (__props.employee)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "member__mail-footer",
          innerHTML: __props.employee.mail_footer
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}
}

})